import React from 'react'
import styles from './DownloadExtension.css';
import Img1 from '../../images/logo-chrome.svg';
import Img2 from '../../images/logo-firefox.svg';
import Img3 from '../../images/logo-opera.svg';

const cards = [
    {
      image: Img1,
      heading: "Add to Chrome",
      text: "Minimum version 62",
      btn: "Add & Install Extension"
    },
    {
      image: Img2,
      heading: "Add to Firefox",
      text: "Minimum version 55",
      btn: "Add & Install Extension"
    },
    {
      image: Img3,
      heading: "Add to Opera",
      text: "Minimum version 46",
      btn: "Add & Install Extension"
    }
  ];
  


export default function DownloadExtension() {

    
  return (
    <section id='download' className='download'>
        <div className="download-ext-container">
        <h3>Download the extension</h3>
        <p>We’ve got more browsers in the pipeline. Please do let us know if you’ve got a favourite you’d like us to prioritize.</p>
        <div className="article-container">

        {cards.map((card) => (
        
             <article key={card.heading} className="custom-card-class">
             <img src={card.image} alt="chrome image" />
             <h5>{card.heading}</h5>
             <small>{card.text}</small>
             <hr />
             <button className='download-ext-btn'>{card.btn}</button>
         </article>

          ))}

        </div>

        </div>
    </section>
  )
}
